import {
  COUNTRY_DE,
  COUNTRY_AT,
  COUNTRY_IT,
  COUNTRY_NL,
  COUNTRY_FR,
  B2B,
  B2C,
  BOT_PATTERN,
} from '@frodo/lib/utils/common/constants';
import { CountryType, CustomerType } from '@frodo/models/types';

export const userTypeStr = (isB2B: boolean = false): CustomerType => {
  return isB2B ? B2B : B2C;
};

export const isServer = typeof window === 'undefined';

export const DOMAIN = isServer
  ? process.env.YVES_INTERNAL_DOMAIN
  : window.location.origin;

export function extractCountryCode(hostName: string): CountryType {
  const countrySpecifiers = [
    COUNTRY_DE,
    COUNTRY_AT,
    COUNTRY_IT,
    COUNTRY_NL,
    COUNTRY_FR,
  ];

  const currentCountry = countrySpecifiers.find(
    country =>
      hostName.includes(`.${country}`) || hostName.includes(`-${country}`),
  );

  if (currentCountry) {
    return currentCountry ?? COUNTRY_DE;
  }

  return process.env.NEXT_PUBLIC_COUNTRY || 'de';
}

export const limitedPromiseAll = async <T, R>(
  items: T[],
  fn: (item: T, index: number) => Promise<R>,
  batchSize = 20,
): Promise<R[]> => {
  const results: R[] = [];

  for (let i = 0; i < items.length; i += batchSize) {
    const batch = items.slice(i, i + batchSize);
    const batchResults = await Promise.all(
      batch.map((item, idx) => fn(item, i + idx)),
    );
    results.push(...batchResults);
  }

  return results;
};

export const isBot = (userAgent: string): boolean => {
  if (!userAgent) {
    return true;
  }

  return BOT_PATTERN.test(userAgent);
};

export const isMatchingProductSku = (searchTerm: string): boolean => {
  if (!searchTerm) {
    return false;
  }

  return /^(c|b)?\d+(:?x\d+)?$/.test(searchTerm);
};
